// errors constants
export const FEATURE_TYPE = 'feature';
export const FEATURE_ERROR_MESSAGE = 'Select at least one feature';
export const SPACE_DIMENSION_TYPE = 'spaceDimension';
export const SPACE_DIMENSION_ERROR_MESSAGE = 'Select Space dimension is required';
